import {ComponentProps} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {LeadFormAskForFullOffer} from "../lead_form/LeadFormAskForFullOffer";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormAskForFullOffer>, "customHeader" | "isTwoColumnGrid" | "showRodoInFooter">;

export const LeadFormModalStandard = (props: IProps) => {
    const {formCloseSnapshotRef, handleModalClose} = props;

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalClose}
            title="Zapytaj dewelopera o pełną ofertę"
            titleClassName={titleStyle}
            testId={OFFER_TEST_IDS.LEAD_FORM.OFFER_LEAD_FORM}
        >
            <LeadFormAskForFullOffer
                {...props}
                formCloseSnapshotRef={formCloseSnapshotRef}
                handleModalClose={handleModalClose}
                customHeader={null}
                isTwoColumnGrid
                showRodoInFooter={false}
            />
        </LeadFormModalWrapper>
    );
};

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
import {ComponentProps} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {LeadFormAskForFullOffer} from "../lead_form/LeadFormAskForFullOffer";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormAskForFullOffer>, "customHeader" | "isTwoColumnGrid" | "showRodoInFooter">;

export const LeadFormModalStandard = (props: IProps) => {
    const {formCloseSnapshotRef, handleModalClose} = props;

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalClose}
            title="Zapytaj dewelopera o pełną ofertę"
            titleClassName={titleStyle}
            testId={OFFER_TEST_IDS.LEAD_FORM.OFFER_LEAD_FORM}
        >
            <LeadFormAskForFullOffer
                {...props}
                formCloseSnapshotRef={formCloseSnapshotRef}
                handleModalClose={handleModalClose}
                customHeader={null}
                isTwoColumnGrid
                showRodoInFooter={false}
            />
        </LeadFormModalWrapper>
    );
};

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
